<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M3 3h18v2H3V3m4 4h10v2H7V7m-4 4h18v2H3v-2m4 4h10v2H7v-2m-4 4h18v2H3v-2z"/>
    </svg>
</template>

<script>
export default {
    name: 'FormatAlignCenterIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
